import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-change-deductions',
  templateUrl: './change-deductions.component.html',
  styleUrls: ['./change-deductions.component.css']
})

export class ChangeDeductionsComponent implements OnInit {
  loadingDeductions:boolean=true;
  selected:string='change-deductions'
  mobileView: boolean = false;
  message:string='';
  unlimited:any
  fixed_amount:any;
  loading:boolean=false;
  toCompleteData:any;
  note:string='';
  constructor(private http:HttpClient) { }

  ngOnInit(): void {
    this.getChangedDeduction();
  }

  getChangedDeduction(){
  const url=`${environment.apiConfig.uri}/admin/Candidates/payouts`;
  this.loadingDeductions = true;
  this.http.get(url).subscribe(
    (response: any) => {
      this.unlimited = response.data.unlimited.filter((item: { status: number; }) => item.status === 1);
      this.fixed_amount = response.data.fixed_amount.filter((item: { status: number; }) => item.status === 1);
      this.loadingDeductions = false;
    },
    (error) => {
      console.error("Error fetching deductions:", error);
      this.loadingDeductions = false;
    })
  }

  completeDeduction(item:any){
    this.loading=false;
    this.message='';
    this.toCompleteData=item;
  }
  confirmSubmit(note:any){
    this.message='';
    this.loading=true;
    const pdid=this.toCompleteData.pdid;
    const uid=this.toCompleteData.uid;
    const id=this.toCompleteData.id;
    const requestUrl=`${environment.apiConfig.uri}/admin/Candidates/CompleteDeductionsPayout?pdid=${pdid}&uid=${uid}&id=${id}&note=${note}`
    this.http.post(requestUrl,'').subscribe((res:any)=>{
      try {
        this.getChangedDeduction();
        this.message=res.message;
        this.note=''
        this.loading=false;       
      } catch (error:any) {
        this.message="An unexpected error occurred. Please try again later.";
        this.loading=false;
      }
    })

  }
 onClickView(item: any) {
  if (!item.fileStream) {
    this.http.get(`${environment.apiConfig.uri}/admin/File/GetFileStream/Candidate/${item.fileId}`, 
      { responseType: 'text' }).subscribe(
      (response: any) => {
        try {
          // Try to parse as JSON first
          const jsonResponse = JSON.parse(response);
          if (jsonResponse && jsonResponse.data) {
            item.fileStream = jsonResponse.data;
            item.fileName = jsonResponse.data.fileName || 'document.pdf';
          }
        } catch (e) {
          // If not JSON, treat as base64 content directly
          item.fileStream = response;
          item.fileName = item.fileName || 'document.pdf';
        }
        // Now that we have the fileStream, open the file
        this.openFile(item);
      },
      error => {
        console.error('Error fetching file:', error);
      }
    );
  } else {
    // If fileStream is already available, open the file directly
    this.openFile(item);
  }
}

// Helper method to open the file
private openFile(item: any) {
  const link = document.createElement('a');
  link.target = '_blank';
  const blob = this.dataURItoBlob(item);
  const file = new File([blob], item.fileName || 'document.pdf', {
    type: this.getMimeType(item.fileName || 'document.pdf'),
  });
  let url = window.URL.createObjectURL(file);
  link.href = url;
  link.click();
}

dataURItoBlob(item: any) {
  const byteString = window.atob(item.fileStream);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const int8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    int8Array[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([int8Array], {
    type: this.getMimeType(item.fileName),
  });
  return blob;
}

getMimeType(fileName: string): string {
  const extension = fileName.split('.').pop()?.toLowerCase();
  switch (extension) {
    case 'pdf': return 'application/pdf';
    case 'jpg': 
    case 'jpeg': return 'image/jpeg';
    case 'png': return 'image/png';
    case 'gif': return 'image/gif';
    case 'mp4': return 'video/mp4';
    case 'mov': return 'video/quicktime';
    case 'avi': return 'video/x-msvideo';
    case 'mp3': return 'audio/mpeg';
    case 'webp': return 'image/webp';
    case 'docx': return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    default: return 'application/pdf'; // Default to PDF
  }
}
}
